class Flyout {
	constructor($el) {
		this.$el = $el;
		this.$content = this.$el.find('[data-flyout="content"]');
		this.$background = this.$el.find('[data-flyout="background"]');
		this.calculateHeight();
	}

	calculateHeight = () => {
		this.$background.css('height', this.$content.outerHeight());
	};

	setTop = top => {
		this.$background.css('top', `${top}px`);
	};
}

export default Flyout;
